export default __webpack_public_path__ + "static/media/gallery_04.bd5c2847.jpg";